import * as React from 'react';

interface Props {
    catalogUrl: string;
    thumbnailUrl: string;
    label: string;
}

const CatalogTile: React.FC<Props> = (props) => {
    return (
        <a
            href={props.catalogUrl}
            className="nts-catalog-tile"
            target="_blank"
            rel="noopener noreferrer"
        >
            <img alt="thumbnail" src={props.thumbnailUrl} />

            <div className="nts-catalog-tile-label">
                {props.label}
            </div>
        </a>
    );
};

export default CatalogTile;
